import { createInteractionMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { MORE_ACTIONS_DROPDOWN_INTERACTION } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const MORE_ACTIONS_DROPDOWN_METRIC = createInteractionMetric({
	key: MORE_ACTIONS_DROPDOWN_INTERACTION,
});
